export default __webpack_public_path__ + "static/media/File_Thuyet_Minh.cc0bf108.zip";